import React, { useState } from "react";
import { CaseDetail } from "../../../models/CaseDetail/caseDetail.model";
import { Menu, Popover, Table, Tooltip } from "antd";
import { Report } from "../../../models/Report/report.model";
import { DownloadFileTypeEnum } from "../../../enums/downloadFileType.enum";
import ReportService from "../../../services/Report/report.service";
import moment from "moment";
import "./reportHistory.scss";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import AuthContainer from "../../../store/container/AuthContainer";
import { UserRoleEnum } from "../../../enums/userRole.enum";

interface ReportHistoryProps extends AuthReducerProps {
    caseDetail?: CaseDetail
};

const ReportHistory = ({caseDetail, user, userRole}: ReportHistoryProps) => {
    const [downloadLoading, setDownloadLoading] = useState(false);

    const handleDownloadReport = (
        caseDetail: CaseDetail,
        fileType: DownloadFileTypeEnum,
        withLetterHead: boolean,
        reportId?: number,
      ) => {
        setDownloadLoading(true);
        if (caseDetail?.id) {
          const apiMethod = userRole === UserRoleEnum.SCAN_CENTER ? ReportService.downloadScanCenterReport : ReportService.downloadReport;
          apiMethod(
            fileType,
            caseDetail,
            withLetterHead,
            reportId ?? 0,
            (reportUrl: string) => {
              window.open(reportUrl, "_blank");
            },
            () => {},
            () => {
                setDownloadLoading(false);
            }
          );
        }
      };

    const handleViewReport = (
        caseDetail: CaseDetail,
        reportId?: number,
    ) => {
        setDownloadLoading(true);
        if (caseDetail?.id) {
            const apiMethod = userRole === UserRoleEnum.SCAN_CENTER ? ReportService.previewScanCenterReport : ReportService.previewReport;
            apiMethod(
                caseDetail?.id,
                reportId ?? 0,
                (data: Blob) => {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([data], { type: "application/pdf" })
                    );
                    const pdfWindow = window.open(fileURL, "_blank");
                    if (pdfWindow) {
                        pdfWindow.onload = () => {
                            window.URL.revokeObjectURL(fileURL);
                        };
                    }
                },
                () => {},
                () => {
                    setDownloadLoading(false);
                }
            );
        }
    };

    const columns = [
        {
            title: "Report",
            dataIndex: "id",
            key: "id",
            render: (_: number, report: Report) => <div>{report?.getReportName()}</div>
        },
        {
            title: "Reported Time",
            dataIndex: "id",
            key: "id",
            render: (_: number, report: Report) => <div>{moment(report?.updatedAt).format('hh:mm A')}</div>
        },
        {
            title: "Reported Doctor",
            dataIndex: "reportedDoctor",
            key: "reportedDoctor"
        },
        {
            title: "View",
            dataIndex: "id",
            key: "id",
            render: (_: number, report: Report) => <div>
                <Tooltip title="View Report">
                    <div
                        className="report-history__download-link"
                        onClick={() => {
                            if (caseDetail) {
                                handleViewReport(
                                    caseDetail,
                                    report?.id
                                );
                            }
                        }}
                    >
                        View
                    </div>
                </Tooltip>
            </div>
        },
        {
            title: "Download",
            dataIndex: "id",
            key: "id",
            render: (_: number, report: Report) => <div>
                <Tooltip title="Download Report">
                <Popover
                      destroyTooltipOnHide
                      overlayClassName="admin-cases__assignment-popover"
                      placement="bottomLeft"
                      content={
                        <div>
                            {
                                caseDetail &&
                                <Menu mode="vertical" className="border-none">
                                    <Menu.Item
                                    className="navbar-item m-0"
                                    key="with_letterhead"
                                    onClick={() => {
                                        handleDownloadReport(
                                        caseDetail,
                                        DownloadFileTypeEnum.PDF,
                                        true,
                                        report?.id
                                        );
                                    }}
                                    >
                                    Download with Letterhead
                                    </Menu.Item>
                                    <Menu.Item
                                    className="navbar-item m-0"
                                    key="without_letterhead"
                                    onClick={() => {
                                        handleDownloadReport(
                                        caseDetail,
                                        DownloadFileTypeEnum.PDF,
                                        false,
                                        report?.id
                                        );
                                    }}
                                    >
                                    Download without Letterhead
                                    </Menu.Item>
                                    <Menu.Item
                                    className="navbar-item m-0"
                                    key="as_word"
                                    onClick={() => {
                                        handleDownloadReport(
                                        caseDetail,
                                        DownloadFileTypeEnum.WORD,
                                        false,
                                        report?.id
                                        );
                                    }}
                                    >
                                    Download as Word
                                    </Menu.Item>
                                </Menu>
                            }
                        </div>
                      }
                      title="Download Report"
                      trigger="click"
                    >
                      <div onClick={(e) => e.preventDefault()} className="report-history__download-link">Download</div>
                    </Popover>
                </Tooltip>
            </div>
        }
    ]
    return (
        <div className="">
            <h3>Report History</h3>
            <Table 
                dataSource={caseDetail?.reports ?? []}
                columns={columns}
            />
        </div>
    );
};

export default AuthContainer(ReportHistory);